import {
    Description,
    Span,
    Card,
    Top,
    Image,
    Body,
    Name,
    Degree,
    Date,
} from './EducationCardStyledComponent';

const EducationCard = ({ education }) => {
    return (
        <Card>
            <Top>
                <Image src={education.img} />
                <Body>
                    <Name>
                        <a
                            href={education.schoolLink}
                            target='_blank'
                            rel='noopener noreferrer'
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {education.school}
                        </a>
                    </Name>
                    <Degree>{education.degree}</Degree>
                    <Date>{education.date}</Date>
                </Body>
            </Top>

            <Description>
                <Span>{education.desc}</Span>
            </Description>
        </Card>
    );
};

export default EducationCard;
